const Heading = {
  baseStyle: {
    letterSpacing: `wide`,
  },
};

export default Heading;
